import type { MarketFreshness } from "./types";

export function compactNumber(value: number | null | undefined, currency = false): string {
  if (value === null || value === undefined || Number.isNaN(value)) return "-";
  const abs = Math.abs(value);
  const prefix = currency ? "$" : "";
  if (abs >= 1_000_000_000_000) return `${prefix}${(value / 1_000_000_000_000).toFixed(2)}T`;
  if (abs >= 1_000_000_000) return `${prefix}${(value / 1_000_000_000).toFixed(2)}B`;
  if (abs >= 1_000_000) return `${prefix}${(value / 1_000_000).toFixed(2)}M`;
  if (abs >= 1_000) return `${prefix}${(value / 1_000).toFixed(1)}K`;
  return `${prefix}${value.toLocaleString("en-US")}`;
}

export function signedPct(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value)) return "-";
  const sign = value > 0 ? "+" : "";
  return `${sign}${value.toFixed(2)}%`;
}

export function freshnessLabel(generatedAt: string | null | undefined): string {
  if (!generatedAt) return "not built";
  const diffMs = Date.now() - new Date(generatedAt).getTime();
  if (diffMs < 0) return "just now";
  const mins = Math.floor(diffMs / 60_000);
  if (mins < 1) return "<1m ago";
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 48) return `${hours}h ago`;
  return `${Math.floor(hours / 24)}d ago`;
}

export function rowTone(value: number | null | undefined): "up" | "down" | "flat" {
  if (!value) return "flat";
  return value > 0 ? "up" : "down";
}

export function marketFreshnessLabel(freshness: MarketFreshness | null | undefined): string {
  if (!freshness) return "unchecked";
  if (freshness.status === "fresh") return "Fresh";
  if (freshness.status === "backfill") return `Backfill ${freshness.selectedTradeDate}`;
  return `Stale by ${freshness.selectedLagTradingDays} sessions`;
}

export function marketFreshnessTone(freshness: MarketFreshness | null | undefined): "up" | "down" | "warn" {
  if (!freshness) return "warn";
  if (freshness.status === "fresh") return "up";
  return freshness.selectedLagTradingDays > 1 ? "down" : "warn";
}
